/*
  Material design: [Radio button](https://material.io/guidelines/components/selection-controls.html#selection-controls-radio-button)

  `com-radio-button` allows the user to select one option from a set. User radio buttons for exclusive selection if you think that the user needs to see all available options side-by-side. Otherwise, consider a dropdown, which uses less space than displaying all options.

  Example:
    <com-radio-button></com-radio-button>
    <com-radio-button checked></com-radio-button>

  ### Styling
*/
/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/
import { PolymerElement, html } from '@polymer/polymer';
import './style/com-radio-button-style';

import { COMCheckedElementBehavior } from '@com/checked-element-behavior';

class COMRadioButton extends COMCheckedElementBehavior(PolymerElement) {
  static get template() {
    return html`
    <style include="com-theme"></style>
    <style include="com-radio-button-style"></style>

    <div id="radioWrapper" class\$="[[_computeElementClass(checked, disabled, error, hover)]]">
      <div id="radioButton"></div>
    </div>
`;
  }

  static get is() { return 'com-radio-button'; }

  static get properties() {
    return {
      role: {
        type: String,
        value: "radio",
        reflectToAttribute: true
      },
      tabindex: {
        type: Number,
        value: 0,
        reflectToAttribute: true
      },
      ariaChecked: String,
      ariaActiveAttribute: {
        type: String,
        value: "aria-checked"
      },
      checked: {
        type: Boolean,
        value: false,
        notify: true
      },
      error: {
        type: Boolean,
        value: false
      },
      disabled: {
        type: Boolean,
        value: false
      },
      hover: {
        type: Boolean,
        value: false
      }
    };
  }

  /**
   * @desc Set class for the element state or behavior. Added this method to fix linting errors
   * @param {Boolean} checked
   * @param {Boolean} disabled
   * @param {Boolean} error
   * @param {Boolean} hover
   * @return {String} className
   */
  _computeElementClass(checked, disabled, error, hover) {
    return super.computeElementClass(checked, disabled, error, hover);
  }
}

window.customElements.define(COMRadioButton.is, COMRadioButton);
